exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3DcSl2g8ZpE2vtlTI8xayS{max-width:600px!important}._2BJsOqRbcE_ooifiZMjvzX{display:inline-block}html[dir] ._1nQ07i5eDTxGGTo6ZXcOha,html[dir] ._22XGe5Z1k3gAkiDvlTy2JX{margin-top:10px}", ""]);

// exports
exports.locals = {
	"dialog": "_3DcSl2g8ZpE2vtlTI8xayS",
	"spinner": "_2BJsOqRbcE_ooifiZMjvzX",
	"advanced": "_1nQ07i5eDTxGGTo6ZXcOha",
	"checkbox": "_22XGe5Z1k3gAkiDvlTy2JX"
};